// Bilingual dictionary EN/ES for Cabo Unstoppable
export const translations = {
  en: {
    seo: {
      siteTitle: "Cabo Unstoppable | Born in Los Cabos",
      description:
        "Cabo Unstoppable is a premium lifestyle brand born in Los Cabos, inspired by ambition, resilience, discipline and the mindset to keep moving forward.",
      shareDescription:
        "Cabo Unstoppable is a premium lifestyle brand born in Los Cabos, inspired by ambition, resilience and the mindset to keep moving forward.",
      product: "The Original Cabo Unstoppable Cap | Cabo Unstoppable",
      shop: "Shop | Cabo Unstoppable",
      about: "About Cabo Unstoppable | Born in Los Cabos",
      aboutDescription:
        "Discover Cabo Unstoppable, a premium lifestyle and apparel brand born in Los Cabos, Mexico, inspired by the energy, ambition and resilience of Cabo.",
      contact: "Contact | Cabo Unstoppable",
      checkout: "Checkout | Cabo Unstoppable",
      orderSuccess: "Order Confirmed | Cabo Unstoppable",
      cabo: "Los Cabos | Cabo Unstoppable",
      mindset: "Unstoppable Mindset | Cabo Unstoppable",
      notFound: "Page Not Found | Cabo Unstoppable",
    },
    notFound: {
      overline: "CABO UNSTOPPABLE",
      title: "This page doesn't exist.",
      body: "The page you're looking for was moved or never existed. Everything Cabo Unstoppable lives on our homepage.",
      cta: "Back to the homepage",
    },
    nav: {
      home: "Home",
      shop: "Shop",
      cabo: "Los Cabos",
      mindset: "Unstoppable Mindset",
      lifestyle: "Lifestyle",
      community: "Community",
      about: "About",
      contact: "Contact",
      cart: "Cart",
      menu: "Menu",
    },
    hero: {
      overline: "LOS CABOS · MX",
      coords: "22.89° N · 109.92° W",
      location: "LOS CABOS · BCS · MX",
      launchLabel: "FLAGSHIP · DROP 01",
      title: "BE UNSTOPPABLE",
      subtitle: "Discipline. Ambition. Cabo.",
      capTitle1: "The Cabo",
      capTitle2: "Unstoppable Cap",
      capSubtitle: "Built for Those Who Never Stop",
      capDescription:
        "Where it all begins. The first piece from Cabo Unstoppable and the release that marks the beginning of the movement. Our signature cap combines premium materials, comfort, and distinctive details inspired by Los Cabos. Built to keep up with your pace — from a morning workout to a day at the beach, an afternoon in the city, the office, or your next destination. A versatile piece designed for those who always have somewhere to be, something to build, and a next goal to chase. The first release. The beginning of Cabo Unstoppable.",
      capDescLead: "THE FIRST RELEASE OF CABO UNSTOPPABLE",
      capDescBody:
        "The piece that starts it all. Made to move with you — from the gym to the beach, the office, the city, and wherever comes next.",
      capDescCloser: "This is where it begins.",
      shopNow: "View the cap",
      discover: "Discover the mindset",
      scroll: "Scroll",
      featureA: "PRICE",
      featureB: "SHIPPING",
      featureC: "GLOBAL",
      statLaunchLabel: "LAUNCH",
      statLaunchValue: "Soon",
      statBornInLabel: "BORN IN",
      statBornInValue: "Cabo",
      originalBadge: "THE ORIGINAL",
      viewProductOverlay: "View product",
      marquee: [
        "BE UNSTOPPABLE",
        "THE ORIGINAL · CABO CAP",
        "BORN IN CABO",
        "WEAR THE MINDSET",
        "THE ORIGINAL IS HERE",
      ],
    },
    caboSection: {
      chapterOverline: "CHAPTER I · THE ORIGIN",
      titleLine1: "Born in",
      titleLine2: "Los Cabos.",
      subtitle:
        "More than a destination. A place that inspires those who never stop moving forward.",
      para1:
        "Cabo Unstoppable was born in Los Cabos — a place where the desert meets the ocean, where every sunrise brings a new opportunity, and where ambition feels limitless.",
      para2:
        "More than one of the world's most beautiful destinations, Los Cabos represents movement, resilience, and the drive to keep evolving. Every day, entrepreneurs, athletes, creators, travelers, and dreamers arrive with one thing in common: the desire to become something greater.",
      quoteLine1: "This city doesn't stand still.",
      quoteLine2: "Neither do we.",
      aerialLabel: "Where desert meets ocean",
      harborOverline: "AN UNSTOPPABLE COMMUNITY",
      harborTitleLine1: "A story of",
      harborTitleHighlight: "strength.",
      harborBody:
        "Los Cabos is also a story of strength. Over the years, our community has faced hurricanes and difficult moments that have tested the entire region. And every time, Los Cabos has risen, rebuilt, and kept moving forward. That ability to come together, adapt, and return stronger is part of who we are. Because here, being unstoppable doesn't mean never falling. It means always rising again.",
    },
    mindsetSection: {
      chapterOverline: "CHAPTER II · THE PHILOSOPHY",
      titleLine1: "The Unstoppable",
      titleLine2: "Mindset.",
      subtitle:
        "Success begins long before achievement. It begins with how you choose to think.",
      manifesto: [
        "Being unstoppable isn't about never facing obstacles.",
        "It's about refusing to let obstacles define you.",
        "It's choosing discipline when motivation disappears.",
        "It's continuing when progress feels invisible.",
        "It's believing that every small step moves you closer to the person you're becoming.",
      ],
      resilienceOverline: "RESILIENCE",
      resilienceTitle: "Where the tide meets discipline.",
      focusOverline: "FOCUS",
      ambitionOverline: "AMBITION",
      dailyEffortOverline: "DAILY EFFORT",
      dailyEffortTitle: "Show up when nobody's watching.",
      forDecidersOverline: "FOR THE ONES WHO DECIDE",
      forDecidersBody:
        "Cabo Unstoppable exists for people who wake up every day determined to build something greater than yesterday.",
      closingLine1: "Being unstoppable",
      closingLine2Before: "isn't a ",
      closingLine2Highlight: "destination.",
      closingSub: "It's a decision you make every single day.",
    },
    showcase: {
      overline: "FLAGSHIP PRODUCT",
      title: "One cap. One mindset.",
      viewProduct: "View product",
      shopCta: "View the cap",
      details: "Full details",
      trust1: "First release · Drop 01",
      trust2: "Designed in Los Cabos",
      trust3: "22.89° N · 109.92° W",
    },
    about: {
      overline: "OUR STORY",
      title: "Born in Los Cabos.",
      title2: "Built for the unstoppable.",
      brandName: "Cabo Unstoppable",
      introP1:
        "Cabo Unstoppable is a premium lifestyle and apparel brand born in Los Cabos, Mexico. Created to represent the energy, ambition and resilience of our community, we create pieces designed for those who keep moving forward — in sport, business, creativity and everyday life.",
      introP2a: "Cabo isn't just part of our name.",
      introP2b: "It's where we come from.",
      statement1: "Our origin is Cabo.",
      statement2: "Our direction is forward.",
      whyOverline: "WHY CABO",
      whyTitle1: "More than a destination.",
      whyTitle2: "This is home.",
      whyP1:
        "Los Cabos is known for where the desert meets the ocean, its beaches, its energy and a way of life recognized around the world.",
      whyP2: "But to us, Cabo represents something more.",
      whyP3:
        "It is a community of people who build, work, create, train, take risks and keep moving forward. A community that has faced difficult moments and, time after time, has risen, rebuilt and continued.",
      whyP4:
        "That ability to keep moving forward is part of the identity of Cabo Unstoppable.",
      pillar1Title: "Born in Cabo",
      pillar1Copy:
        "Our story begins in Los Cabos. The landscape, people, energy and resilience of this place are permanently connected to the identity of Cabo Unstoppable.",
      pillar2Title: "Built with purpose",
      pillar2Copy:
        "Every Cabo Unstoppable piece should feel intentional. From design and materials to details and presentation, the goal is to create products worthy of carrying the name.",
      pillar3Title: "Be unstoppable",
      pillar3Copy:
        "Being unstoppable doesn't mean never falling. It means continuing forward, adapting and rising again.",
      finalTitle1: "Born in Cabo.",
      finalTitle2: "Built to go beyond it.",
      finalP1: "Cabo is where our story begins, not where it ends.",
      finalP2:
        "Cabo Unstoppable was born in Los Cabos with the vision of building something that can travel far beyond its shores — a brand and community connected by the ambition to keep moving forward.",
      finalMark: "Be Unstoppable.",
      finalCta: "Discover The Original",
      imgAltIntro:
        "The Cabo Unstoppable community wearing the brand's tees in Los Cabos, Mexico",
      imgAltWhy:
        "Aerial view of Land's End and the bay of Cabo San Lucas at sunset, Los Cabos, Mexico",
      imgAltHero:
        "Aerial view of the Los Cabos coastline where the desert rocks meet the turquoise ocean",
    },
    featured: {
      overline: "THE COLLECTION",
      title: "Featured Drop",
      subtitle: "Premium tees, caps & hoodies built for the ones who don't quit.",
      viewAll: "View all products",
      addToCart: "Add to cart",
      quickAdd: "Quick add",
      soldOut: "Sold out",
      new: "NEW",
    },
    mindset: {
      overline: "THE PHILOSOPHY",
      title: "The Unstoppable Mindset",
      paragraph1:
        "Cabo Unstoppable is more than clothing. It is a mindset — a frequency for those who refuse limits and chase the sun.",
      paragraph2:
        "From the gym floor to the open ocean, from the boardroom to the coastline — this brand represents those who never stop.",
      paragraph3: "Be unstoppable.",
      stat1: { label: "AMBITION", value: "100%" },
      stat2: { label: "DISCIPLINE", value: "24/7" },
      stat3: { label: "BORN IN", value: "CABO" },
    },
    gallery: {
      overline: "CABO LIFESTYLE",
      title: "Where the coast meets the code",
      subtitle: "Gym. Ocean. Sunsets. Ambition.",
    },
    community: {
      overline: "#CABOUNSTOPPABLE",
      title: "Join the Unstoppable Community",
      subtitle:
        "Tag us. Share your grind. Wear the mindset. We repost the movement every Sunday.",
      cta: "Share your story",
    },
    newsletter: {
      overline: "FIRST ACCESS",
      title: "Be first to shop",
      subtitle: "The Original Cabo Unstoppable Cap is here. Online store coming soon — join the list for first access.",
      placeholder: "your@email.com",
      cta: "Notify me",
      subscribing: "Joining...",
      success: "You're on the list.",
      error: "Something went wrong. Try again.",
    },
    footer: {
      explore: "Explore",
      connect: "Connect",
      location: "Location",
      originalCap: "The Original Cap",
      rights: "All rights reserved.",
      tagline: "Born in Los Cabos. Built for the unstoppable.",
    },
    cart: {
      title: "Your Cart",
      empty: "Your cart is empty",
      emptyCta: "Start shopping",
      subtotal: "Subtotal",
      shipping: "Shipping",
      tax: "Tax",
      free: "Free",
      total: "Total",
      discount: "Discount",
      checkout: "Checkout",
      continue: "Continue shopping",
      remove: "Remove",
      size: "Size",
      color: "Color",
      quantity: "Qty",
      coupon: "Have a coupon?",
      couponPlaceholder: "COUPON CODE",
      apply: "Apply",
      applied: "Applied",
      couponInvalid: "Invalid or expired code",
      shippingEstimate: "Estimated · calculated at checkout",
      freeShippingHint: "Add {amount} more for free shipping",
    },
    product: {
      size: "Size",
      color: "Color",
      addToCart: "Add to cart",
      buyNow: "Buy now",
      added: "Added to cart",
      description: "Description",
      highlights: "Highlights",
      shipping: "Shipping",
      shippingCopy:
        "Free worldwide shipping on orders over $100. Standard shipping $12. Delivered in 3–7 business days.",
      returns: "Returns",
      returnsCopy:
        "30-day free returns on unworn items with original tags. Refunded to original payment method within 5 business days.",
      material: "Material & Care",
      materialCopy:
        "Machine wash cold with like colors. Do not bleach. Tumble dry low. Iron reverse.",
      inStock: "In stock",
      lowStock: "Only {n} left",
      outOfStock: "Sold out",
      youMightLike: "You might also like",
      sku: "SKU",
      zoomHint: "Hover to zoom · click for full view",
    },
    checkout: {
      title: "Checkout",
      step1: "Contact",
      step2: "Shipping",
      step3: "Payment",
      email: "Email",
      fullName: "Full name",
      phone: "Phone",
      address: "Street address",
      city: "City",
      state: "State / Province",
      postal: "ZIP / Postal code",
      country: "Country",
      placeOrder: "Place order",
      placing: "Placing order...",
      orderSummary: "Order summary",
      backToShop: "Back to shop",
      success: "Order placed",
      successCopy: "Your order has been received. We'll email you shortly with tracking.",
      orderNumber: "Order number",
      paymentMethod: "Payment method",
      card: "Credit / Debit card",
      paypal: "PayPal",
      applePay: "Apple Pay",
      cardNumber: "Card number",
      expiry: "MM / YY",
      cvc: "CVC",
      cardName: "Name on card",
      secureNote: "Secure encrypted checkout · SSL protected",
      redirectPaypal: "You'll be redirected to PayPal to complete payment",
      redirectApple: "Touch ID or Face ID will complete payment",
      applyCoupon: "Apply coupon",
    },
    shop: {
      title: "The Collection",
      subtitle:
        "Our launch drop. One product, one mindset — the Cabo Unstoppable Cap. More drops arriving soon.",
      empty: "Nothing here yet. Check back soon.",
      moreSoon: "MORE DROPS · COMING SOON",
      all: "All",
      tshirts: "T-Shirts",
      caps: "Caps",
      hoodies: "Hoodies",
      shorts: "Shorts",
    },
    success: {
      overline: "ORDER CONFIRMED",
      itemsOrdered: "Items ordered",
      shipTo: "Shipping to",
      paidWith: "Paid with",
      printReceipt: "Print receipt",
    },
    contact: {
      overline: "CONTACT",
      title1: "Get in",
      title2: "touch.",
      intro:
        "Have a question, collaboration idea, or want to know more about Cabo Unstoppable? We'd love to hear from you.",
      emailLabel: "EMAIL",
      emailNote: "Prefer email? Write to us directly.",
      formOverline: "WRITE TO US",
      nameLabel: "Name",
      emailFieldLabel: "Email",
      messageLabel: "Message",
      namePlaceholder: "Your name",
      emailPlaceholder: "you@email.com",
      messagePlaceholder: "Tell us what's on your mind",
      sending: "Sending",
      send: "Send message",
      successTitle: "Message sent",
      successBody: "Thank you for reaching out. We'll get back to you soon.",
      sendAnother: "Send another message",
      sentError: "Your message couldn't be sent right now. Please try again in a moment.",
    },
    checkoutMisc: {
      cardMissing: "Please complete payment details",
      orderFailed: "Order failed. Please try again.",
      noCardStored: "No card data stored",
      trustSecure: "Secure payment",
      trustShip: "Ships worldwide",
    },
    comingSoon: {
      badge: "Online Store Coming Soon",
      button: "Coming Soon",
      title: "Online Store Coming Soon",
      body: "The Original Cabo Unstoppable Cap is here. We're putting the finishing touches on our online store — join the list to be first to order.",
      drawerTitle: "Online Store Coming Soon",
      drawerBody: "The Original Cabo Unstoppable Cap is here. Online ordering opens soon — join the list to be first in line.",
      availHere: "The Original is here.",
      availOnline: "Online store coming soon",
      newsletterCta: "Be first to shop",
      newsletterHint: "Drop your email — we'll ping you the moment the store goes live.",
      close: "Close",
    },
  },
  es: {
    seo: {
      siteTitle: "Cabo Unstoppable | Born in Los Cabos",
      description:
        "Cabo Unstoppable es una marca premium nacida en Los Cabos, inspirada en la ambición, la resiliencia, la disciplina y la mentalidad de seguir siempre adelante.",
      shareDescription:
        "Cabo Unstoppable es una marca premium nacida en Los Cabos, inspirada en la ambición, la resiliencia y la mentalidad de seguir siempre adelante.",
      product: "La Gorra Original Cabo Unstoppable | Cabo Unstoppable",
      shop: "Tienda | Cabo Unstoppable",
      about: "Nosotros | Cabo Unstoppable — Nacido en Los Cabos",
      aboutDescription:
        "Conoce Cabo Unstoppable, una marca premium de lifestyle y apparel nacida en Los Cabos, México, inspirada por la energía, ambición y resiliencia de Cabo.",
      contact: "Contacto | Cabo Unstoppable",
      checkout: "Checkout | Cabo Unstoppable",
      orderSuccess: "Pedido Confirmado | Cabo Unstoppable",
      cabo: "Los Cabos | Cabo Unstoppable",
      mindset: "Mentalidad Unstoppable | Cabo Unstoppable",
      notFound: "Página no encontrada | Cabo Unstoppable",
    },
    notFound: {
      overline: "CABO UNSTOPPABLE",
      title: "Esta página no existe.",
      body: "La página que buscas fue movida o nunca existió. Todo Cabo Unstoppable vive en nuestra página principal.",
      cta: "Volver al inicio",
    },
    nav: {
      home: "Inicio",
      shop: "Tienda",
      cabo: "Los Cabos",
      mindset: "Mentalidad Unstoppable",
      lifestyle: "Lifestyle",
      community: "Comunidad",
      about: "Nosotros",
      contact: "Contacto",
      cart: "Carrito",
      menu: "Menú",
    },
    hero: {
      overline: "LOS CABOS · MX",
      coords: "22.89° N · 109.92° W",
      location: "LOS CABOS · BCS · MX",
      launchLabel: "FLAGSHIP · DROP 01",
      title: "BE UNSTOPPABLE",
      subtitle: "Disciplina. Ambición. Cabo.",
      capTitle1: "La Gorra",
      capTitle2: "Cabo Unstoppable",
      capSubtitle: "Diseñada para los que nunca se detienen",
      capDescription:
        "Donde todo comienza. La primera pieza de Cabo Unstoppable y el lanzamiento que marca el inicio del movimiento. Nuestra gorra insignia combina materiales premium, comodidad y detalles distintivos inspirados en Los Cabos. Diseñada para seguir tu ritmo — desde un entrenamiento por la mañana hasta un día en la playa, una tarde en la ciudad, la oficina o tu próximo destino. Una pieza versátil creada para quienes siempre tienen a dónde ir, algo que construir y un próximo objetivo por perseguir. El primer lanzamiento. El inicio de Cabo Unstoppable.",
      capDescLead: "EL PRIMER LANZAMIENTO DE CABO UNSTOPPABLE",
      capDescBody:
        "La pieza que lo empieza todo. Hecha para acompañarte — del gimnasio a la playa, la oficina, la ciudad, y a donde sigas.",
      capDescCloser: "Aquí es donde comienza.",
      shopNow: "Ver la gorra",
      discover: "Descubre la mentalidad",
      scroll: "Desliza",
      featureA: "PRECIO",
      featureB: "ENVÍO",
      featureC: "GLOBAL",
      statLaunchLabel: "LANZAMIENTO",
      statLaunchValue: "Pronto",
      statBornInLabel: "NACIDO EN",
      statBornInValue: "Cabo",
      originalBadge: "LA ORIGINAL",
      viewProductOverlay: "Ver producto",
      marquee: [
        "BE UNSTOPPABLE",
        "LA ORIGINAL · GORRA CABO",
        "NACIDO EN CABO",
        "VIVE LA MENTALIDAD",
        "VENTA EN LÍNEA PRÓXIMAMENTE",
      ],
    },
    caboSection: {
      chapterOverline: "CAPÍTULO I · EL ORIGEN",
      titleLine1: "Nacido en",
      titleLine2: "Los Cabos.",
      subtitle:
        "Más que un destino. Un lugar que inspira a quienes nunca dejan de avanzar.",
      para1:
        "Cabo Unstoppable nació en Los Cabos — un lugar donde el desierto se encuentra con el océano, donde cada amanecer trae una nueva oportunidad, y donde la ambición se siente sin límites.",
      para2:
        "Más que uno de los destinos más hermosos del mundo, Los Cabos representa movimiento, resiliencia y las ganas de seguir evolucionando. Cada día llegan emprendedores, atletas, creadores, viajeros y soñadores con una cosa en común: el deseo de convertirse en algo más grande.",
      quoteLine1: "Esta ciudad no se detiene.",
      quoteLine2: "Nosotros tampoco.",
      aerialLabel: "Donde el desierto encuentra el océano",
      harborOverline: "UNA COMUNIDAD IMPARABLE",
      harborTitleLine1: "Una historia de",
      harborTitleHighlight: "fortaleza.",
      harborBody:
        "Los Cabos también es una historia de fortaleza. A lo largo de los años, nuestra comunidad ha enfrentado huracanes y momentos difíciles que han puesto a prueba a toda la región. Y cada vez, Los Cabos se ha levantado, reconstruido y seguido adelante. Esa capacidad de unirnos, adaptarnos y volver más fuertes forma parte de nuestra identidad. Porque aquí, ser imparable no significa nunca caer. Significa siempre volver a levantarse.",
    },
    mindsetSection: {
      chapterOverline: "CAPÍTULO II · LA FILOSOFÍA",
      titleLine1: "La Mentalidad",
      titleLine2: "Unstoppable.",
      subtitle:
        "El éxito comienza mucho antes del logro. Comienza con la manera en que eliges pensar.",
      manifesto: [
        "Ser imparable no significa nunca enfrentar obstáculos.",
        "Es negarte a permitir que los obstáculos te definan.",
        "Es elegir disciplina cuando la motivación desaparece.",
        "Es continuar cuando el progreso se siente invisible.",
        "Es creer que cada pequeño paso te acerca a la persona en la que te estás convirtiendo.",
      ],
      resilienceOverline: "RESILIENCIA",
      resilienceTitle: "Donde la marea encuentra la disciplina.",
      focusOverline: "ENFOQUE",
      ambitionOverline: "AMBICIÓN",
      dailyEffortOverline: "ESFUERZO DIARIO",
      dailyEffortTitle: "Aparece cuando nadie está viendo.",
      forDecidersOverline: "PARA QUIENES DECIDEN",
      forDecidersBody:
        "Cabo Unstoppable existe para las personas que despiertan cada día decididas a construir algo más grande que ayer.",
      closingLine1: "Ser imparable",
      closingLine2Before: "no es un ",
      closingLine2Highlight: "destino.",
      closingSub: "Es una decisión que tomas cada día.",
    },
    showcase: {
      overline: "PRODUCTO INSIGNIA",
      title: "Una gorra. Una mentalidad.",
      viewProduct: "Ver producto",
      shopCta: "Ver la gorra",
      details: "Detalles completos",
      trust1: "Primer lanzamiento · Drop 01",
      trust2: "Diseñada en Los Cabos",
      trust3: "22.89° N · 109.92° W",
    },
    about: {
      overline: "NUESTRA HISTORIA",
      title: "Nacido en Los Cabos.",
      title2: "Construido para los imparables.",
      brandName: "Cabo Unstoppable",
      introP1:
        "Cabo Unstoppable es una marca premium de lifestyle y apparel nacida en Los Cabos, México. Creada para representar la energía, ambición y resiliencia de nuestra comunidad, desarrollamos piezas diseñadas para acompañar a quienes siguen avanzando — en el deporte, los negocios, la creatividad y la vida diaria.",
      introP2a: "Cabo no es solo parte de nuestro nombre.",
      introP2b: "Es nuestro origen.",
      statement1: "Nuestro origen es Cabo.",
      statement2: "Nuestra dirección, adelante.",
      whyOverline: "POR QUÉ CABO",
      whyTitle1: "Más que un destino.",
      whyTitle2: "Nuestro origen.",
      whyP1:
        "Los Cabos es conocido por el encuentro entre el desierto y el océano, por sus playas, su energía y una forma de vida reconocida alrededor del mundo.",
      whyP2: "Pero para nosotros, Cabo también representa algo más.",
      whyP3:
        "Es una comunidad de personas que construyen, trabajan, emprenden, entrenan, crean y siguen avanzando. Una comunidad que ha enfrentado momentos difíciles y que, una y otra vez, ha sabido levantarse, reconstruir y continuar.",
      whyP4:
        "Esa capacidad de avanzar es parte de la identidad de Cabo Unstoppable.",
      pillar1Title: "Nacido en Cabo",
      pillar1Copy:
        "Nuestra historia comienza en Los Cabos. El paisaje, la gente, la energía y la resiliencia de este lugar están conectados de forma permanente con la identidad de Cabo Unstoppable.",
      pillar2Title: "Creado con propósito",
      pillar2Copy:
        "Cada pieza de Cabo Unstoppable debe sentirse intencional. Desde el diseño y los materiales hasta los detalles y la presentación, el objetivo es crear productos dignos de llevar el nombre.",
      pillar3Title: "Be unstoppable",
      pillar3Copy:
        "Ser imparable no significa nunca caer. Significa seguir adelante, adaptarse y levantarse otra vez.",
      finalTitle1: "Nacido en Cabo.",
      finalTitle2: "Creado para ir más allá.",
      finalP1: "Cabo es donde comienza nuestra historia, no donde termina.",
      finalP2:
        "Cabo Unstoppable nace en Los Cabos con la visión de construir algo que pueda viajar mucho más allá de sus costas — una marca y una comunidad unidas por la ambición de seguir avanzando.",
      finalMark: "Be Unstoppable.",
      finalCta: "Descubre The Original",
      imgAltIntro:
        "La comunidad Cabo Unstoppable con las playeras de la marca en Los Cabos, México",
      imgAltWhy:
        "Vista aérea de Land's End y la bahía de Cabo San Lucas al atardecer, Los Cabos, México",
      imgAltHero:
        "Vista aérea de la costa de Los Cabos donde las rocas del desierto se encuentran con el océano turquesa",
    },
    featured: {
      overline: "LA COLECCIÓN",
      title: "Drop Destacado",
      subtitle: "Playeras premium, gorras y sudaderas para los que no se rinden.",
      viewAll: "Ver todos los productos",
      addToCart: "Añadir al carrito",
      quickAdd: "Añadir",
      soldOut: "Agotado",
      new: "NUEVO",
    },
    mindset: {
      overline: "LA FILOSOFÍA",
      title: "La Mentalidad Unstoppable",
      paragraph1:
        "Cabo Unstoppable es más que ropa. Es una mentalidad — una frecuencia para los que rechazan los límites y persiguen el sol.",
      paragraph2:
        "Del gimnasio al océano, de la oficina a la costa — esta marca representa a los que nunca se detienen.",
      paragraph3: "Sé imparable.",
      stat1: { label: "AMBICIÓN", value: "100%" },
      stat2: { label: "DISCIPLINA", value: "24/7" },
      stat3: { label: "NACIDO EN", value: "CABO" },
    },
    gallery: {
      overline: "LIFESTYLE CABO",
      title: "Donde la costa encuentra el código",
      subtitle: "Gimnasio. Océano. Atardeceres. Ambición.",
    },
    community: {
      overline: "#CABOUNSTOPPABLE",
      title: "Únete a la Comunidad Unstoppable",
      subtitle:
        "Etiquétanos. Comparte tu esfuerzo. Vive la mentalidad. Repostéamos el movimiento cada domingo.",
      cta: "Comparte tu historia",
    },
    newsletter: {
      overline: "ACCESO ANTICIPADO",
      title: "Sé el primero en comprar",
      subtitle: "La Gorra Original Cabo Unstoppable ya está aquí. Venta en línea próximamente — únete a la lista para acceso anticipado.",
      placeholder: "tu@email.com",
      cta: "Avísame",
      subscribing: "Uniéndote...",
      success: "Estás en la lista.",
      error: "Algo salió mal. Intenta de nuevo.",
    },
    footer: {
      explore: "Explora",
      connect: "Conecta",
      location: "Ubicación",
      originalCap: "La Gorra Original",
      rights: "Todos los derechos reservados.",
      tagline: "Nacido en Los Cabos. Construido para los imparables.",
    },
    cart: {
      title: "Tu carrito",
      empty: "Tu carrito está vacío",
      emptyCta: "Explorar tienda",
      subtotal: "Subtotal",
      shipping: "Envío",
      tax: "Impuesto",
      free: "Gratis",
      total: "Total",
      discount: "Descuento",
      checkout: "Finalizar compra",
      continue: "Seguir comprando",
      remove: "Eliminar",
      size: "Talla",
      color: "Color",
      quantity: "Cant.",
      coupon: "¿Tienes un cupón?",
      couponPlaceholder: "CÓDIGO",
      apply: "Aplicar",
      applied: "Aplicado",
      couponInvalid: "Código inválido o vencido",
      shippingEstimate: "Estimado · calculado al pagar",
      freeShippingHint: "Añade {amount} más para envío gratis",
    },
    product: {
      size: "Talla",
      color: "Color",
      addToCart: "Añadir al carrito",
      buyNow: "Comprar ahora",
      added: "Añadido al carrito",
      description: "Descripción",
      highlights: "Detalles clave",
      shipping: "Envío",
      shippingCopy:
        "Envío mundial gratuito en pedidos +$100. Envío estándar $12. Entrega en 3–7 días hábiles.",
      returns: "Devoluciones",
      returnsCopy:
        "30 días de devoluciones gratis en artículos sin usar con etiquetas originales. Reembolso en 5 días hábiles.",
      material: "Material y cuidado",
      materialCopy:
        "Lavar en frío con colores similares. No usar blanqueador. Secar a baja temperatura. Planchar al revés.",
      inStock: "En stock",
      lowStock: "Solo {n} disponibles",
      outOfStock: "Agotado",
      youMightLike: "También te puede gustar",
      sku: "SKU",
      zoomHint: "Pasa el mouse para zoom · clic para vista completa",
    },
    checkout: {
      title: "Finalizar compra",
      step1: "Contacto",
      step2: "Envío",
      step3: "Pago",
      email: "Email",
      fullName: "Nombre completo",
      phone: "Teléfono",
      address: "Dirección",
      city: "Ciudad",
      state: "Estado / Provincia",
      postal: "Código postal",
      country: "País",
      placeOrder: "Realizar pedido",
      placing: "Procesando...",
      orderSummary: "Resumen del pedido",
      backToShop: "Volver a la tienda",
      success: "Pedido realizado",
      successCopy: "Hemos recibido tu pedido. Te enviaremos un email con seguimiento.",
      orderNumber: "Número de pedido",
      paymentMethod: "Método de pago",
      card: "Tarjeta de crédito / débito",
      paypal: "PayPal",
      applePay: "Apple Pay",
      cardNumber: "Número de tarjeta",
      expiry: "MM / AA",
      cvc: "CVC",
      cardName: "Nombre en la tarjeta",
      secureNote: "Pago seguro cifrado · Protegido con SSL",
      redirectPaypal: "Serás redirigido a PayPal para completar el pago",
      redirectApple: "Touch ID o Face ID completará el pago",
      applyCoupon: "Aplicar cupón",
    },
    shop: {
      title: "La colección",
      subtitle:
        "Nuestro drop de lanzamiento. Un producto, una mentalidad — la Gorra Cabo Unstoppable. Más drops muy pronto.",
      empty: "Nada aún. Vuelve pronto.",
      moreSoon: "MÁS DROPS · MUY PRONTO",
      all: "Todos",
      tshirts: "Playeras",
      caps: "Gorras",
      hoodies: "Sudaderas",
      shorts: "Shorts",
    },
    success: {
      overline: "PEDIDO CONFIRMADO",
      itemsOrdered: "Artículos del pedido",
      shipTo: "Envío a",
      paidWith: "Pagado con",
      printReceipt: "Imprimir recibo",
    },
    contact: {
      overline: "CONTACTO",
      title1: "Ponte en",
      title2: "contacto.",
      intro:
        "¿Tienes alguna pregunta, una idea de colaboración o quieres saber más sobre Cabo Unstoppable? Nos encantará saber de ti.",
      emailLabel: "EMAIL",
      emailNote: "¿Prefieres email? Escríbenos directamente.",
      formOverline: "ESCRÍBENOS",
      nameLabel: "Nombre",
      emailFieldLabel: "Correo electrónico",
      messageLabel: "Mensaje",
      namePlaceholder: "Tu nombre",
      emailPlaceholder: "tu@email.com",
      messagePlaceholder: "Cuéntanos qué tienes en mente",
      sending: "Enviando",
      send: "Enviar mensaje",
      successTitle: "Mensaje enviado",
      successBody: "Gracias por contactarnos. Nos pondremos en contacto contigo pronto.",
      sendAnother: "Enviar otro mensaje",
      sentError: "Tu mensaje no se pudo enviar en este momento. Inténtalo de nuevo en unos minutos.",
    },
    checkoutMisc: {
      cardMissing: "Completa los datos de pago",
      orderFailed: "El pedido falló. Intenta de nuevo.",
      noCardStored: "No guardamos datos de tarjeta",
      trustSecure: "Pago seguro",
      trustShip: "Envío mundial",
    },
    comingSoon: {
      badge: "Venta en línea próximamente",
      button: "Muy pronto",
      title: "Venta en línea próximamente",
      body: "La Gorra Original Cabo Unstoppable ya está aquí. Estamos dando los últimos toques a nuestra tienda en línea — únete a la lista para ser el primero en ordenar.",
      drawerTitle: "Venta en línea próximamente",
      drawerBody: "La Gorra Original Cabo Unstoppable ya está aquí. La venta en línea abre muy pronto — únete a la lista para ser el primero.",
      availHere: "The Original is here.",
      availOnline: "Venta en línea próximamente",
      newsletterCta: "Sé el primero en comprar",
      newsletterHint: "Deja tu email — te avisamos en cuanto abramos la tienda.",
      close: "Cerrar",
    },
  },
};

export const getProductName = (product, lang) =>
  lang === "es" && product.name_es ? product.name_es : product.name;

export const getProductDescription = (product, lang) =>
  lang === "es" && product.description_es
    ? product.description_es
    : product.description;

export const getProductHighlights = (product, lang) =>
  lang === "es" && product.highlights_es?.length
    ? product.highlights_es
    : product.highlights || [];
